import type { Address } from "./Address.js";
import { Country } from "./Country.js";

export const personalPickupAddress: Address = {
	firstName: "Father’s",
	lastName: "Coffee Roastery",
	city: "Ostrava-Stará Bělá",
	country: Country.Czechia,
	street: "Mitrovická 128/66",
	zip: "724 00",
};
